module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_call_map-30e72fe51e6827bbc075cbda9c7f9c9e.png";